import type { ComponentContentSchema, SlotGroupDefinition } from '@vibesites/runtime';
import { EditableSlotGroup, RichTextContent } from '@vibesites/runtime/react';
import {
  INNER_PAGE_HERO_TITLE_CLASS,
  InnerPageHeroSection,
} from './shared/InnerPageHeroSection';

const bgImageDef: SlotGroupDefinition = {
  label: 'Background Image',
  fields: {
    image: {
      label: 'Image',
      type: 'image',
      defaultField: 'property_featured_image',
    },
    alt: {
      label: 'Alt Text',
      type: 'text',
      defaultValue: 'Accessibility banner',
    },
  },
};


export function AccessibilityHero() {
  return (
    <InnerPageHeroSection
      bgGroupPath="accessibilityhero.bg_image"
      bgImageDef={bgImageDef}
      altFallback="Accessibility banner"
    >
      <RichTextContent
        path="accessibilityhero.title"
        as="h1"
        className={INNER_PAGE_HERO_TITLE_CLASS}
      />
      <EditableSlotGroup
        groupPath="accessibilityhero.bg_image"
        definition={bgImageDef}
        className="hidden"
        style={{ display: 'none' }}
      >
        <span />
      </EditableSlotGroup>
    </InnerPageHeroSection>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'AccessibilityHero',
  displayName: 'Accessibility Hero',
  tokens: {
    'accessibilityhero.title': {
      label: 'Title',
      type: 'richtext',
      defaultValue: '<p>Accessibility</p>',
    },
  },
  slotGroups: {
    'accessibilityhero.bg_image': bgImageDef,
  },
};

(AccessibilityHero as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default AccessibilityHero;
